module.exports = __webpack_public_path__ + "img/fluffys_paw_on_the_trapdoor.a0938cc7.jpg";